// Shared width scale for overlay primitives (PPDialog, PPDrawer).
// Replaces per-consumer bespoke pixel widths so every overlay picks from one scale.
export type OverlaySize = 'sm' | 'md' | 'lg' | 'xl'

export const OVERLAY_SIZES: Record<OverlaySize, number> = {
  sm: 460,
  md: 520,
  lg: 600,
  xl: 680
}
